import type { RequestQueryOptions } from '@entities/lesson/model/types/api'
import { rpc } from '@server/infrastructure/rpc'
import { withRequestTimeout } from '@shared/apis/with-request-timeout'

type TutorExclusionMutationResponse = { success: boolean }

export const tutorExclusionMutations = {
  blockTutor: ({ bearerToken }: RequestQueryOptions) => ({
    mutationKey: ['tutor-exclusion', 'block', bearerToken],
    mutationFn: async ({ tutorId, classId }: { tutorId: number; classId?: number }) => {
      return await withRequestTimeout(async (signal) => {
        const response = await rpc.api.v1['tutor-exclusion'].block.$post(
          { json: { tutorId, classId } },
          { headers: { Authorization: `Bearer ${bearerToken}` }, init: { signal } },
        )
        if (!response.ok) {
          throw new Error(`Failed to block tutor: ${response.status}`)
        }
        const result = await response.json()
        if (result?.success !== true) {
          throw new Error('Tutor was not blocked')
        }
        return result
      })
    },
  }),

  unblockTutor: ({ bearerToken }: RequestQueryOptions) => ({
    mutationKey: ['tutor-exclusion', 'unblock', bearerToken],
    mutationFn: async (tutorId: number) => {
      const response = await rpc.api.v1['tutor-exclusion'].unblock.$post(
        { json: { tutorId } },
        { headers: { Authorization: `Bearer ${bearerToken}` } },
      )
      return response.json() as Promise<TutorExclusionMutationResponse>
    },
  }),
} as const
